<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line" :class="warningFlagTop1">
          <div class="device-block-line-chart">
            <DoubleGraph :opts="humidityLineOptsTop1" :series="humidityLineDataTop1"></DoubleGraph>
          </div>
          <div class="device-block-bar-chart">
            <SinglePieHistogramWrap :opts="humidityBarOptsTop1" :series="humidityBarDataTop1"></SinglePieHistogramWrap>
          </div>
        </div>

        <div class="column-line">
          <div class="device-block-line-chart">
            <DoubleGraph :opts="humidityLineOptsBottom1" :series="humidityLineDataBottom1"></DoubleGraph>
          </div>
          <div class="device-block-bar-chart">
            <SinglePieHistogramWrap :opts="humidityBarOptsBottom1" :series="humidityBarDataBottom1"></SinglePieHistogramWrap>
          </div>
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line" :class="warningFlagTop2">
          <div class="device-block-line-chart">
            <DoubleGraph :opts="humidityLineOptsTop2" :series="humidityLineDataTop2"></DoubleGraph>
          </div>
          <div class="device-block-bar-chart">
            <SinglePieHistogramWrap :opts="humidityBarOptsTop2" :series="humidityBarDataTop2"></SinglePieHistogramWrap>
          </div>
        </div>

        <div class="column-line">
          <div class="device-block-line-chart">
            <DoubleGraph :opts="humidityLineOptsBottom2" :series="humidityLineDataBottom2"></DoubleGraph>
          </div>
          <div class="device-block-bar-chart">
            <SinglePieHistogramWrap :opts="humidityBarOptsBottom2" :series="humidityBarDataBottom2"></SinglePieHistogramWrap>
          </div>
        </div>
      </div>
      <div class="main-column-multi-line">
        <div class="column-line" :class="warningFlagTop3">
          <div class="device-block-line-chart">
            <DoubleGraph :opts="humidityLineOptsTop3" :series="humidityLineDataTop3"></DoubleGraph>
          </div>
          <div class="device-block-bar-chart">
            <SinglePieHistogramWrap :opts="humidityBarOptsTop3" :series="humidityBarDataTop3"></SinglePieHistogramWrap>
          </div>
        </div>

        <div class="column-line">
          <div class="device-block-line-chart">
            <DoubleGraph :opts="humidityLineOptsBottom3" :series="humidityLineDataBottom3"></DoubleGraph>
          </div>
          <div class="device-block-bar-chart">
            <SinglePieHistogramWrap :opts="humidityBarOptsBottom3" :series="humidityBarDataBottom3"></SinglePieHistogramWrap>
          </div>
        </div>
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>
      
      <script>
import configJson from "./config/station.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      stationIndex: "",
      stationType: "",
      stationVentNameFix: "",

      deviceList: [],

      humidityLineDataTop1: null,
      humidityBarDataTop1: null,
      humidityLineDataTop2: null,
      humidityBarDataTop2: null,
      humidityLineDataTop3: null,
      humidityBarDataTop3: null,
      humidityLineDataBottom1: null,
      humidityBarDataBottom1: null,
      humidityLineDataBottom2: null,
      humidityBarDataBottom2: null,
      humidityLineDataBottom3: null,
      humidityBarDataBottom3: null,

      warningFlagTop1: "",
      warningFlagTop2: "",
      warningFlagTop3: "",
      warningFlagBottom1: "",
      warningFlagBottom2: "",
      warningFlagBottom3: "",

      runningTimeDataLeft: null,
      runningTimeDataRight: null,
    };
  },
  computed: {
    humidityLineOptsTop1: function () {
      return {
        title: this.stationIndex + "制备站" + this.stationType + "设备Z1" + this.stationVentNameFix + "出口温湿度趋势",
        legend1: "出口湿度",
        legend2: "出口温度",
        useXAxisLabel: true,
      };
    },
    humidityBarOptsTop1: function () {
      return {
        title: "Z1" + this.stationVentNameFix + "出口实时",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineOptsTop2: function () {
      return {
        title: this.stationIndex + "制备站" + this.stationType + "设备N1" + this.stationVentNameFix + "出口温湿度趋势",
        legend1: "出口湿度",
        legend2: "出口温度",
        useXAxisLabel: true,
      };
    },
    humidityBarOptsTop2: function () {
      return {
        title: "N1" + this.stationVentNameFix + "出口实时",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineOptsTop3: function () {
      return {
        title: this.stationIndex + "制备站" + this.stationType + "设备Z2" + this.stationVentNameFix + "出口温湿度趋势",
        legend1: "出口湿度",
        legend2: "出口温度",
        useXAxisLabel: true,
      };
    },
    humidityBarOptsTop3: function () {
      return {
        title: "Z2" + this.stationVentNameFix + "出口实时",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineOptsBottom1: function () {
      return {
        title: this.stationIndex + "制备站" + this.stationType + "设备N2" + this.stationVentNameFix + "出口温湿度趋势",
        legend1: "出口湿度",
        legend2: "出口温度",
        useXAxisLabel: true,
      };
    },
    humidityBarOptsBottom1: function () {
      return {
        title: "N2" + this.stationVentNameFix + "出口实时",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineOptsBottom2: function () {
      return {
        title: this.stationIndex + "制备站" + this.stationType + "设备Z3" + this.stationVentNameFix + "出口温湿度趋势",
        legend1: "出口湿度",
        legend2: "出口温度",
        useXAxisLabel: true,
      };
    },
    humidityBarOptsBottom2: function () {
      return {
        title: "Z3" + this.stationVentNameFix + "出口实时",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    humidityLineOptsBottom3: function () {
      return {
        title: this.stationIndex + "制备站" + this.stationType + "设备N3" + this.stationVentNameFix + "出口温湿度趋势",
        legend1: "出口湿度",
        legend2: "出口温度",
        useXAxisLabel: true,
      };
    },
    humidityBarOptsBottom3: function () {
      return {
        title: "Z1" + this.stationVentNameFix + "出口实时",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    runningTimeTitleRight: function () {
      return "风机运行时间";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagTop1 = "";
      this.warningFlagTop2 = "";
      this.warningFlagTop3 = "";
      this.warningFlagBottom1 = "";
      this.warningFlagBottom2 = "";
      this.warningFlagBottom3 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationId = configJson[routerName].stationId;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationType = configJson[routerName].stationType;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
    },
    findDeviceId(deviceName) {
      //for backup pages
      return "GUID";

      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      //for backup pages
      return { data: { errorLevel: "Warning", dataList: [] } };

      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        res.data["GUID"] = {
          dataId: null,
          deviceId: "GUID",
          value: null,
          createdDate: "0001-01-01T00:00:00",
          dataDate: "0001-01-01T00:00:00",
          dataType: "VALUE",
          errorLevel: "Warning",
        };

        const currentData = res.data;

        this.setPieHistogramDataAndError(currentData, "humidityBarDataTop1", "1#出口温度", "1#出口湿度", "warningFlagTop1");
        this.setPieHistogramDataAndError(currentData, "humidityBarDataTop2", "2#出口温度", "2#出口湿度", "warningFlagTop2");
        this.setPieHistogramDataAndError(currentData, "humidityBarDataTop3", "3#出口温度", "3#出口湿度", "warningFlagTop3");
        this.setPieHistogramDataAndError(currentData, "humidityBarDataBottom1", "4#出口温度", "4#出口湿度", "warningFlagBottom1");
        this.setPieHistogramDataAndError(currentData, "humidityBarDataBottom2", "5#出口温度", "5#出口湿度", "warningFlagBottom2");
        this.setPieHistogramDataAndError(currentData, "humidityBarDataBottom3", "6#出口温度", "6#出口湿度", "warningFlagBottom3");
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "1#出口温度";
      let humidityDeviceName = "1#出口湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataTop1", "warningFlagTop1");
          })
        );

      temperatureDeviceName = "2#出口温度";
      humidityDeviceName = "2#出口湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataTop2", "warningFlagTop2");
          })
        );

      temperatureDeviceName = "3#出口温度";
      humidityDeviceName = "3#出口湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataTop3", "warningFlagTop3");
          })
        );

      temperatureDeviceName = "4#出口温度";
      humidityDeviceName = "4#出口湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataBottom1", "warningFlagBottom1");
          })
        );

      temperatureDeviceName = "5#出口温度";
      humidityDeviceName = "5#出口湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataBottom2", "warningFlagBottom2");
          })
        );

      temperatureDeviceName = "6#出口温度";
      humidityDeviceName = "6#出口湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataBottom3", "warningFlagBottom3");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>
      
      <style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  //   & div {
  //     border: 1px solid;
  //   }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 3px);

    display: flex;
    justify-content: space-between;
    align-items: stretch;
    position: relative;

    background-color: rgba(255, 255, 255, 0.6);
  }

  .main-column {
    width: calc(100% / 3 - 5px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-multi-line {
    width: calc(100% / 3 - 3px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;
    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;
    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .device-block-line-chart {
    width: 75%;
    height: 100%;
  }

  .device-block-bar-chart {
    width: 24%;
    height: 100%;
  }
}
</style>
      